export const getEntityLabel = (value, fallback = "") => {
  if (value == null) return fallback;
  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }
  if (typeof value !== "object") return fallback;

  return [value.name, value.title, value.code, value.uuid]
    .find((candidate) => typeof candidate === "string" && candidate.trim()) || fallback;
};

export const getEntitySearchText = (value) =>
  getEntityLabel(value, "").toLowerCase();
